import React from 'react'
import { Card, Col, Row, Form, Button, Badge, Dropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom'
import LoadingModal from "../../../components/modal/LoadingModal";
import SimpleModal from "../../../components/modal/SimpleModal";

import { getCustomer} from '../../../resources/API';
import { toCapitalize, INDIVIDUAL, toDecimalFormat } from '../../../resources/Utils';
import ViewRequestForChange from '../components/ViewRequestForChangeCustomer';
import MerchantInfo from '../components/MerchantInfo';
import CustomerInfo from './components/CustomerInfo'
import PaymentInfo from './components/PaymentInfo';
import WaiveInfo from '../components/WaiveInfo';

export default class IndividualCustomer extends React.Component {

  constructor(props) {
    super(props)
    var actionAllow = ['view'];
    if (!actionAllow.includes(props.match.params.action)){
        props.history.push("/notFound");
    }
    this.state = {
      modal :{
        header : null,
        body : null,
        footer : null,
        show : false,
        variant : 'danger'
      },
      account: false,
      action: props.match.params.action,
      customerProfile : {
        id: '',
        isActive: '',
        merchantInfo : {
          isExisted : false,
          isEPayment : false,
          merchantId : '',
          merchantName : ''
        },
        customerInfo : {
          isExisted : false,
          customerId : '',
          fullName : '',
          email : '',
          contactNumber : ''
        },
        paymentInfo : {
          bankAccts: [],
          accountNo : "",
          prefix: "",
          userId: "",
          merchantCustomerId : "",
          paymentChannel: "PGW",
          regisChannel: "PGW"
        },
        waiveInfo : {
          isWaive : "N",
          isValidTillCancel : false,
          waiveFrom : "",
          waiveTo : "",
          waiveType : "F",
          waiveBy : "",
          waiveAmt : "",
          waivePercentage : ""
        }
      },
      identification: {
        citizenId: {
          value: "",
          isExisted: false
        },
        passportNumber: {
          value: "",
          isExisted: false
        },
        alienId: {
          value: "",
          isExisted: false
        }
      },
      viewChange :null,
      modalViewChangeShow: false,
      loadingShow : false,
      approvalStatus : {
        isPendingApproval : null,
        action : null,
        username : null
      }
    }
  }



  componentDidMount(){
    this.getData(this.state.action);
  }

  getData = async (pageAction) => {
    this.setState({loadingShow : true});
    const {custProfileId} = this.props.location.state;
    if (pageAction === 'view' || pageAction === 'update'){
      const customerResponse = await getCustomer(custProfileId);
 
      if (customerResponse.status !== 200 ) {
        window.location = '/notfound';
      }
      const customerProfile = customerResponse.body.customerProfileResponse;
      const bankAccts = customerProfile.customerPaymentInfo.bankAccts;
      const {isPendingApproval, action, lastUsername} = customerResponse.body;


      this.setState({
        customerProfile : {
          id: customerProfile.custProfileId,
          isActive: customerProfile.isActive,
          merchantInfo : {
            isExisted: true,
            isEPayment : customerProfile.customerPaymentInfo.userId !== "",
            merchantId : customerProfile.merchantId,
            merchantName : customerProfile.merchantName
          },
          customerInfo : {
            isExisted: true,
            customerId : customerProfile.customerId,
            fullName : customerProfile.customerInfo.fullName,
            email : customerProfile.customerInfo.email,
            contactNumber : customerProfile.customerInfo.phoneNumber
          },
          paymentInfo : {
            bankAccts: bankAccts,
            accountNo : customerProfile.customerPaymentInfo.bankAccts[0],
            prefix: customerProfile.customerPaymentInfo.prefix,
            userId: customerProfile.customerPaymentInfo.userId,
            merchantCustomerId : customerProfile.customerPaymentInfo.customerId,
            paymentChannel: customerProfile.customerPaymentInfo.customerPaymentChannel,
            regisChannel: customerProfile.customerPaymentInfo.customerRegisterChannel
          },
          waiveInfo : {
            isWaive : customerProfile.waiveInfo.waiveFlag,
            isValidTillCancel : customerProfile.waiveInfo.isAlwaysValid === "Y",
            waiveFrom : customerProfile.waiveInfo.waiveFrom,
            waiveTo : customerProfile.waiveInfo.waiveTo,
            waiveType : customerProfile.waiveInfo.waiveType,
            waiveBy : customerProfile.waiveInfo.waiveBy,
            waiveAmt : toDecimalFormat(customerProfile.waiveInfo.waiveAmt),
            waivePercentage : toDecimalFormat(customerProfile.waiveInfo.waivePercentage)
          }
        },
        approvalStatus : {
          isPendingApproval : isPendingApproval,
          action : action,
          username : lastUsername
        },
        identification: {
          citizenId: {
            value: customerProfile.idType === "P1" || customerProfile.idType === undefined ? customerProfile.customerId : "",
            isExisted: false
          },
          passportNumber: {
            value: customerProfile.idType === "P8" ? customerProfile.customerId : "",
            isExisted: false
          },
          alienId: {
            value: customerProfile.idType === "P7" ? customerProfile.customerId : "",
            isExisted: false
          }
        }
      });
    }
    this.setState({loadingShow : false});
  }

  getTextWithAction(action){
    if (action === 'create'){
      return 'created';
    } else {
      return 'updated';
    }
  }

  render() {
    const {role, accessToken, username} = this.props;
    const { action, loadingShow, modal,  modalViewChangeShow, viewChange,
      approvalStatus, identification } = this.state;
    const {id, isActive, merchantInfo, customerInfo, paymentInfo, waiveInfo} = this.state.customerProfile
    const {filterCriteria} = this.props.location.state;
    if (!['view'].includes(action)){
      window.location = '/notfound';
    }
    if (action === 'view' && !role.includes("DD_ACCOUNT_CUSTOMER_PROFILE")) {
      window.location = '/unauthorized';
    }
    
    const disableByMerchantInfo = !merchantInfo.isExisted || (action === 'view');
    const disableByCustomerInfo = !customerInfo.isExisted || (action === 'view');

    return (
      <React.Fragment>
        <Form id="userActionForm" onSubmit={this.handleSubmitCustomer}>
            <ViewRequestForChange
            onClose={()=>{this.setState({modalViewChangeShow:false});}}
            show={modalViewChangeShow}
            onCheckerConfirm={this.handleCheckerConfirm}
            viewChange={viewChange}
            approvalAction={approvalStatus.action}
            />
            <Card className="shadow mx-auto mt-4 card-width-1200 pb-4">
            <Card.Header className="bg-white font-weight-bold text-scb">
                {toCapitalize(action)} Individual Customer
            </Card.Header>
            <Card.Body>
                <Row>
                  <Col sm={6} className="border-right">
                    <MerchantInfo 
                        merchantInfo={merchantInfo}
                        onChange={this.handleInputChange}
                        action={action}
                        onClickFindMerchant={this.handleFindMerchant}
                    />

                    <CustomerInfo 
                        customerInfo={customerInfo}
                        identification={identification}
                        isEPayment={merchantInfo.isEPayment}
                        onChange={this.handleInputChange}
                        disableByMerchantInfo={disableByMerchantInfo}
                        disableByCustomerInfo={disableByCustomerInfo}
                        action={action}
                        onClickFindCustomer={this.handleFindCustomer}
                    />
                  </Col>
                  <Col sm={6}>
                    <PaymentInfo 
                        paymentInfo={paymentInfo}
                        onChange={this.handleInputChange}
                        disabled={disableByMerchantInfo || disableByCustomerInfo}
                        isEPayment={merchantInfo.isEPayment}
                        action={action}
                    />

                    <WaiveInfo 
                        waiveInfo={waiveInfo}
                        onChange={this.handleInputChange}
                        disabled={disableByMerchantInfo || disableByCustomerInfo}
                        action={action}
                    />
                  </Col>
                </Row>
            </Card.Body>
            </Card>
            <Row className="mx-auto card-width-1200 mt-5 mb-5">
            { (action !== 'update') ?
                <Col sm={3} className="p-0">
                    <LinkContainer 
                    to={{
                        pathname : "/customer",
                        state:{
                            filterCriteria:filterCriteria
                            }
                        }
                        } activeClassName="">
                        <Button variant="outline-secondary" block>Back to Customer List</Button>
                    </LinkContainer>
                </Col>
                :
                <Col sm={3} className="p-0">
                    <LinkContainer
                        to={{
                            pathname:"/customer/view/" + id,
                            state:{
                            role:role,
                            accessToken: accessToken,
                            username:username,
                            type: INDIVIDUAL,
                            filterCriteria: filterCriteria,
                            custProfileId: id
                            }
                        }}
                        activeClassName="">
                        <Button variant="outline-secondary" block>Discard Edit</Button>
                    </LinkContainer>
                </Col>
            }
            {
                action === 'create' ?
                <Col sm={{ span: 3, offset: 6 }} className="p-0">
                <Button type="submit" variant="scb" disabled={!(merchantInfo.isExisted && customerInfo.isExisted)} block>Create Customer</Button>
                </Col>
                : action === 'update' ?
                <Col sm={{ span: 3, offset: 6 }} className="p-0">
                <Button type="submit" variant="scb" disabled={!(merchantInfo.isExisted && customerInfo.isExisted)} block>Update Customer</Button>
                </Col>
                :
                <></>
            }
            
            </Row>
        </Form>
        <LoadingModal show={loadingShow} />
        <SimpleModal
          modal={modal}
          onClose={this.handleModalClose}
        />  
      </React.Fragment>
    )
  }
}
